import { defineStore } from 'pinia';
import { ref } from 'vue';

export enum ApiDataFetchingState {
  None,
  Fetching,
  Fetched,
  ContentNotFound,
  UnexpectedError,
}

// eslint-disable-next-line import/prefer-default-export
export const useApiStore = defineStore('api', () => {
  const apiDateFetchingState = ref<ApiDataFetchingState>(ApiDataFetchingState.None);

  function setApiDateFetchingState(value: ApiDataFetchingState) {
    apiDateFetchingState.value = value;
  }

  return {
    apiDateFetchingState,
    setApiDateFetchingState,
  };
});
